import { render, staticRenderFns } from "./uusi-vastuuhenkilo-form.vue?vue&type=template&id=27844af3&"
import script from "./uusi-vastuuhenkilo-form.vue?vue&type=script&lang=ts&"
export * from "./uusi-vastuuhenkilo-form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports